// isMobile
!function (a) {
    var b = /iPhone/i, c = /iPod/i, d = /iPad/i, e = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, f = /Android/i,
        g = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        h = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        i = /IEMobile/i, j = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, k = /BlackBerry/i, l = /BB10/i, m = /Opera Mini/i,
        n = /(CriOS|Chrome)(?=.*\bMobile\b)/i, o = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        p = new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i"), q = function (a, b) {
            return a.test(b)
        }, r = function (a) {
            var r = a || navigator.userAgent, s = r.split("[FBAN");
            return "undefined" != typeof s[1] && (r = s[0]), s = r.split("Twitter"), "undefined" != typeof s[1] && (r = s[0]), this.apple = {
                phone: q(b, r),
                ipod: q(c, r),
                tablet: !q(b, r) && q(d, r),
                device: q(b, r) || q(c, r) || q(d, r)
            }, this.amazon = {
                phone: q(g, r),
                tablet: !q(g, r) && q(h, r),
                device: q(g, r) || q(h, r)
            }, this.android = {
                phone: q(g, r) || q(e, r),
                tablet: !q(g, r) && !q(e, r) && (q(h, r) || q(f, r)),
                device: q(g, r) || q(h, r) || q(e, r) || q(f, r)
            }, this.windows = {
                phone: q(i, r),
                tablet: q(j, r),
                device: q(i, r) || q(j, r)
            }, this.other = {
                blackberry: q(k, r),
                blackberry10: q(l, r),
                opera: q(m, r),
                firefox: q(o, r),
                chrome: q(n, r),
                device: q(k, r) || q(l, r) || q(m, r) || q(o, r) || q(n, r)
            }, this.seven_inch = q(p, r), this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch, this.phone = this.apple.phone || this.android.phone || this.windows.phone, this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet, "undefined" == typeof window ? this : void 0
        }, s = function () {
            var a = new r;
            return a.Class = r, a
        };
    "undefined" != typeof module && module.exports && "undefined" == typeof window ? module.exports = r : "undefined" != typeof module && module.exports && "undefined" != typeof window ? module.exports = s() : "function" == typeof define && define.amd ? define("isMobile", [], a.isMobile = s()) : a.isMobile = s()
}(this);
//https://github.com/tristen/hoverintent
!function (e, t) {
    if ("function" == typeof define && define.amd) define("hoverintent", ["module"], t); else if ("undefined" != typeof exports) t(module); else {
        var n = {exports: {}};
        t(n), e.hoverintent = n.exports
    }
}(this, function (e) {
    "use strict";
    var t = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
        }
        return e
    };
    e.exports = function (e, n, o) {
        function i(e, t) {
            return y && (y = clearTimeout(y)), b = 0, p ? void 0 : o.call(e, t)
        }

        function r(e) {
            m = e.clientX, d = e.clientY
        }

        function u(e, t) {
            if (y && (y = clearTimeout(y)), Math.abs(h - m) + Math.abs(E - d) < x.sensitivity) return b = 1, p ? void 0 : n.call(e, t);
            h = m, E = d, y = setTimeout(function () {
                u(e, t)
            }, x.interval)
        }

        function s(t) {
            return L = !0, y && (y = clearTimeout(y)), e.removeEventListener("mousemove", r, !1), 1 !== b && (h = t.clientX, E = t.clientY, e.addEventListener("mousemove", r, !1), y = setTimeout(function () {
                u(e, t)
            }, x.interval)), this
        }

        function c(t) {
            return L = !1, y && (y = clearTimeout(y)), e.removeEventListener("mousemove", r, !1), 1 === b && (y = setTimeout(function () {
                i(e, t)
            }, x.timeout)), this
        }

        function v(t) {
            L || (p = !0, n.call(e, t))
        }

        function a(t) {
            !L && p && (p = !1, o.call(e, t))
        }

        function f() {
            e.addEventListener("focus", v, !1), e.addEventListener("blur", a, !1)
        }

        function l() {
            e.removeEventListener("focus", v, !1), e.removeEventListener("blur", a, !1)
        }

        var m, d, h, E, L = !1, p = !1, T = {}, b = 0, y = 0,
            x = {sensitivity: 7, interval: 100, timeout: 0, handleFocus: !1};
        return T.options = function (e) {
            var n = e.handleFocus !== x.handleFocus;
            return x = t({}, x, e), n && (x.handleFocus ? f() : l()), T
        }, T.remove = function () {
            e && (e.removeEventListener("mouseover", s, !1), e.removeEventListener("mouseout", c, !1), l())
        }, e && (e.addEventListener("mouseover", s, !1), e.addEventListener("mouseout", c, !1)), T
    }
});
/*! js-cookie v3.0.0-rc.4 | MIT */
!function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self, function () {
        var n = e.Cookies, r = e.Cookies = t();
        r.noConflict = function () {
            return e.Cookies = n, r
        }
    }())
}(this, function () {
    "use strict";

    function e(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) e[r] = n[r]
        }
        return e
    }

    var t = {
        read: function (e) {
            return e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
        }, write: function (e) {
            return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent)
        }
    };
    return function n(r, o) {
        function i(t, n, i) {
            if ("undefined" != typeof document) {
                "number" == typeof (i = e({}, o, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), n = r.write(n, t);
                var c = "";
                for (var u in i) i[u] && (c += "; " + u, !0 !== i[u] && (c += "=" + i[u].split(";")[0]));
                return document.cookie = t + "=" + n + c
            }
        }

        return Object.create({
            set: i, get: function (e) {
                if ("undefined" != typeof document && (!arguments.length || e)) {
                    for (var n = document.cookie ? document.cookie.split("; ") : [], o = {}, i = 0; i < n.length; i++) {
                        var c = n[i].split("="), u = c.slice(1).join("=");
                        '"' === u[0] && (u = u.slice(1, -1));
                        try {
                            var f = t.read(c[0]);
                            if (o[f] = r.read(u, f), e === f) break
                        } catch (e) {
                        }
                    }
                    return e ? o[e] : o
                }
            }, remove: function (t, n) {
                i(t, "", e({}, n, {expires: -1}))
            }, withAttributes: function (t) {
                return n(this.converter, e({}, this.attributes, t))
            }, withConverter: function (t) {
                return n(e({}, this.converter, t), this.attributes)
            }
        }, {attributes: {value: Object.freeze(o)}, converter: {value: Object.freeze(r)}})
    }(t, {path: "/"})
});

window.storefrontApi = "0284b81dfd0c923e470470f86caf73a0";

$s = new function () {
    const self = this;
    this.debounce = function (callback, limit, runImmediately) {
        var tID;
        return function () {
            clearTimeout(tID);
            if (runImmediately) {
                callback();
            }
            tID = setTimeout(function () {
                callback();
            }, limit);
        }
    }
    this.throttle = function (callback, limit) {
        var waiting = false;
        var callAfterWaiting = null;
        return function () {
            if (!waiting) {
                callback.apply(this, arguments);
                waiting = true;
                setTimeout(function () {
                    waiting = false;
                    if (callAfterWaiting) {
                        callAfterWaiting();
                        callAfterWaiting = null;
                    }
                }, limit);
            } else {
                callAfterWaiting = function () {
                    callback.apply(this, arguments);
                }
            }
        }
    }

    this.getPageNavigationType = function () {
        if ("performance" in window && window.performance.navigation && typeof window.performance.navigation.type === "number") {
            const types = ["navigate", "reload", "back_forward", "reserved"];
            return [types[performance.navigation.type]];
        }

        const types = []
        const navigations = performance.getEntriesByType("navigation");
        for (const navigation of navigations) {
            //@ts-ignore
            types.push(navigation.type);
        }
        return types;
    }

    this.getFocusableElements = function (container) {
        return Array.from(container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        ));
    }

    this.scrollToElement = function (selector, offsetTop, behavior) {
        var headerOffset = 0;
        try {
            const header = document.getElementById("shopify-section-header");
            const announcementBar = document.getElementById("shopify-section-announcement_bar");
            headerOffset += header ? parseInt(getComputedStyle(header).getPropertyValue("height").replace('px', '')) : 0;
            headerOffset += announcementBar ? parseInt(getComputedStyle(announcementBar).getPropertyValue("height").replace('px', '')) : 0;
        } catch (e) {
            console.warn(e);
        }
        window.scrollBy({
            left: 0,
            top: document.querySelector(selector).getBoundingClientRect().top - headerOffset - (offsetTop || 20),
            behavior: (behavior || 'smooth')
        });
    }

    var trapFocusStack = [];
    this.trapFocus = function (container, elementToFocus = false) {
        var trapItem = {
            beforeFocus: document.activeElement,
            container: container,
            handlerFocus: function (evt) {
                if (trapFocusStack.length == trapIndex) {
                    if (container !== evt.target && !container.contains(evt.target)) {
                        container.focus();
                    }
                }
            },
            handlerKeyDown: function (evt) {
                if (evt.code.toUpperCase() !== 'TAB') return; // If not TAB key

                var elements = $s.getFocusableElements(container);
                var first = elements[0];
                var last = elements[elements.length - 1];

                if (evt.target === last && !evt.shiftKey) {
                    evt.preventDefault();
                    first.focus();
                }
                if ((evt.target === container || evt.target === first) && evt.shiftKey) {
                    evt.preventDefault();
                    last.focus();
                }
            }
        }
        trapFocusStack.push(trapItem);
        var trapIndex = trapFocusStack.length;
        if (!elementToFocus) {
            elementToFocus = container;
        }
        container.setAttribute('tabindex', '-1');
        elementToFocus.focus();

        container.addEventListener('keydown', trapItem.handlerKeyDown);
        document.addEventListener('focusin', trapItem.handlerFocus);
    }

    this.removeTrapFocus = function () {
        var lastItem = trapFocusStack.pop();
        if (lastItem) {
            if (lastItem.beforeFocus) {
                lastItem.beforeFocus.focus();
            }
            if (lastItem.container) {
                lastItem.container.removeAttribute('tabindex');
                lastItem.container.removeEventListener('keydown', lastItem.handlerKeyDown);
            }
            document.removeEventListener('focusin', lastItem.handlerFocus);
        }
    }

    window.modal = null;
    this.openModal = function (content, css, options = {}) {
        var defaults = {
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: [css],
            onOpen: function () {
                $s.trapFocus(this.modal);
                return true;
            },
            onClose: function () {
                $s.removeTrapFocus();
                if (options.close)
                    options.close();
                return true;
            }
        };
        modal = new tingle.modal(Object.assign(defaults, options));
        modal.setContent(content);
        modal.open();
        return modal;
    }

    this.closeModal = function () {
        if (window.modal && window.modal.modal) {
            window.modal.close();
        }
    }

    this.handleize = function (str) {
        return str.toLowerCase().replace(/\'|\"/g, "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    }

    this.imgUrlFilter = function (url, filter) {
        var position = url.split('?')[0].lastIndexOf('.');
        url = url.substring(0, position) + '_' + filter + url.substring(position);
        return url;
    }

    this.getQueryParam = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    this.randomstring = function (L) {
        var s = '';
        var randomchar = function () {
            var n = Math.floor(Math.random() * 62);
            if (n < 10) return n; //1-10
            if (n < 36) return String.fromCharCode(n + 55); //A-Z
            return String.fromCharCode(n + 61); //a-z
        }
        while (s.length < L) s += randomchar();
        return s;
    }

    this.validateEmail = function (email) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }

    this.formatMoney = function (cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || window.money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
        return formatString.replace(placeholderRegex, value);
    }

    this.matchHeight = function (elements) {
        var height = 0;
        elements.forEach(function (e, ix) {
            e.style.minHeight = '';
        });
        elements.forEach(function (e, ix) {
            height = Math.max(height, e.offsetHeight);
        });
        elements.forEach(function (e, ix) {
            e.style.minHeight = height + 'px';
        });
    }

    this.onImagesLoaded = function (images, callback) {
        var imagesLoaded = 0;
        var loadFunction = function () {
            imagesLoaded++;
            if (imagesLoaded == images.length) {
                callback();
            }
        };
        if (images.length > 0) {
            images.forEach(function (obj) {
                var img = new Image();
                img.onload = loadFunction;
                img.onerror = loadFunction;
                img.src = obj.getAttribute('src');
            });
        } else {
            callback();
        }
    }

    this.pauseAllMedia = function (container) {
        container = container || document;
        container.querySelectorAll('.js-youtube, .js-vimeo, video, product-model').forEach((media) => {
            $s.pauseMedia(media)
        });
    }

    this.pauseMedia = function (media) {
        if (media) {
            if (media.classList.contains('js-youtube')) {
                media.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                return;
            }
            if (media.classList.contains('js-vimeo')) {
                media.contentWindow.postMessage('{"method":"pause"}', '*');
                return;
            }
            if (media.tagName.toLowerCase() == 'video') {
                media.pause();
                return;
            }
            if (media.tagName.toLowerCase() == 'product-model') {
                try {
                    if (model.modelViewerUI) model.modelViewerUI.pause();
                } catch (e) {
                    console.error(e);
                }
                return;
            }
        }
    }

    this.playMedia = function (media) {
        if (media) {
            if (media.classList.contains('js-youtube')) {
                media.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                return;
            }
            if (media.classList.contains('js-vimeo')) {
                media.contentWindow.postMessage('{"method":"play"}', '*');
                return;
            }
            if (media.tagName.toLowerCase() == 'video') {
                media.play();
                return;
            }
            if (media.tagName.toLowerCase() == 'product-model') {
                try {
                    if (model.modelViewerUI) model.modelViewerUI.play();
                } catch (e) {
                    console.error(e);
                }
                return;
            }
        }
    }

    this.media = new function () {
        var self = this;
        var mqS = window.matchMedia("(max-width: " + window.breakpoints.small + ")");
        var mqM = window.matchMedia("(max-width: " + window.breakpoints.medium + ")");
        var mqO = window.matchMedia("(orientation: landscape)");
        var tId = 0;

        function updateMedia() {
            self.isLarge = !mqM.matches;
            self.isMediumUp = !mqS.matches;
            self.isMedium = mqM.matches && !mqS.matches;
            self.isMediumDown = mqM.matches;
            self.isSmall = mqS.matches;
            self.isLandscape = mqO.matches;
        }

        function handler() {
            clearTimeout(tId);
            tId = setTimeout(function () {
                updateMedia();
                window.dispatchEvent(new Event('mediaChange'));
            }, 1);
        }

        updateMedia();
        mqS.addListener(handler);
        mqM.addListener(handler);
        mqO.addListener(handler);
        return this;
    }

    this.isVisible = function (element) {
        return !!(element.offsetWidth > 0 && element.offsetHeight > 0);
    }

    this.isInViewport = function (element) {
        const {top, bottom} = element.getBoundingClientRect();
        const vHeight = (window.innerHeight || document.documentElement.clientHeight);
        return ((top > 0 || bottom > 0) && top < vHeight);
    }

    function slideTransitionEnd(evt) {
        if (evt.propertyName == 'max-height') {
            var panel = evt.target;
            if (panel.style.maxHeight == '0px') {
                panel.style.visibility = 'hidden';
                panel.style.overflow = 'hidden';
            } else {
                panel.style.maxHeight = 'none';
                panel.style.overflow = 'visible';
            }
        }
    }

    this.expand = function (panels, options) {
        var settings = {'duration': 400, 'effect': 'ease-out'}
        if (options) {
            $s.extend(settings, options);
        }
        if (typeof (panels.length) == 'undefined') {
            panels = [panels];
        }
        panels.forEach(function (panel) {
            if (!$s.isVisible(panel)) {
                panel.style.visibility = 'visible';
                panel.removeEventListener('transitionend', slideTransitionEnd);
                panel.style.overflow = 'hidden';
                panel.style.transition = 'max-height ' + settings.duration + 'ms ' + settings.effect;
                var height = panel.scrollHeight + 'px';
                panel.style.maxHeight = height;
                panel.addEventListener('transitionend', slideTransitionEnd);
            }
        });
    }

    this.collapse = function (panels, options) {
        var settings = {'duration': 400, 'effect': 'ease-out'}
        if (options) {
            $s.extend(settings, options);
        }
        if (typeof (panels.length) == 'undefined') {
            panels = [panels];
        }
        panels.forEach(function (panel) {
            if ($s.isVisible(panel)) {
                panel.removeEventListener('transitionend', slideTransitionEnd);
                panel.style.transition = 'max-height ' + settings.duration + 'ms ' + settings.effect;
                var height = panel.scrollHeight + "px";
                panel.style.maxHeight = height;
                setTimeout(() => {
                    panel.style.overflow = 'hidden';
                    panel.style.maxHeight = '0px';
                    panel.addEventListener('transitionend', slideTransitionEnd);
                }, 100) /* workaround to instant collapse*/
            }
        });
    }

    this.toggle = function (panels, options) {
        if (typeof (panels.length) == 'undefined') {
            panels = [panels];
        }
        panels.forEach(function (panel) {
            if ($s.isVisible(panel)) {
                $s.collapse(panel, options);
            } else {
                $s.expand(panel, options);
            }
        });
    }

    var body = document.querySelector('body');
    var html = document.querySelector('html');
    var overlay = document.getElementById('overlay');
    var loadingOverlay = document.getElementById('loading-overlay');

    this.hideScroll = function () {
        //body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
    }

    this.showScroll = function () {
        //body.style.overflow = '';
        html.style.overflow = '';
    }

    this.showOverlay = function () {
        html.classList.add('show-overlay');
    }

    this.hideOverlay = function () {
        html.classList.remove('show-overlay');
    }

    this.showLoadingOverlay = function () {
        html.classList.add('show-loading-overlay');
        $s.trapFocus(loadingOverlay);
    }
    this.hideLoadingOverlay = function () {
        html.classList.remove('show-loading-overlay');
        $s.removeTrapFocus();
    }
    this.addToCartSuccess = function () {
        if (window.SideCart) {
            window.SideCart.updateSideCart(true)
        } else {
            location = '/cart'
        }
    }
    this.addToCartFail = function (msg) {
        $s.hideLoadingOverlay();
        $s.openModal('<div class="error-itemincart">' + msg + '</div>', 'message');
    }
    this.dispatchEvent = function (target, eventName) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, false, true);
        target.dispatchEvent(event);
    }
    this.checkout = function (elementTrigger, discountCode) {
        $s.showLoadingOverlay();
        $s.getJson({
            url: '/cart.json', success: function (data) {
                data.items.forEach(function (item) {
                    if (!discountCode && item.properties && item.properties._discount_code) {
                        discountCode = item.properties._discount_code;
                    }
                })
                location = '/checkout' + (discountCode ? '?discount=' + discountCode : '');
            }
        })
    }
    /* deep merge */
    this.extend = function (target, source) {
        for (const key of Object.keys(source)) {
            if (source[key] instanceof Object) Object.assign(source[key], $s.extend(target[key], source[key]))
        }
        Object.assign(target || {}, source)
        return target;
    }

    this.globalEval = function (textHtmlOrElement) {
        if (typeof (textHtmlOrElement) == "string") {
            var parser = new DOMParser();
            var doc = parser.parseFromString(textHtmlOrElement, 'text/html');
        } else {
            doc = textHtmlOrElement;
        }
        var scripts = doc.querySelectorAll('script');
        scripts.forEach(function (script) {
            if (script.src) {
                var d = document.createElement('script');
                for (var i = 0; i < script.attributes.length; i++) {
                    d.setAttribute(script.attributes[i].name, script.attributes[i].value);
                    document.head.appendChild(d).parentNode.removeChild(d);
                }
            } else {
                if (script.type != 'application/json') {
                    eval(script.innerHTML);
                }
            }
        })
    }

    this.get = function (params) {
        return $s.fetch({...params, type: 'text'});
    }

    this.getJson = function (params) {
        return $s.fetch({...params, type: 'json'});
    }

    this.post = function (params) {
        params.type = params.type || 'json';
        if (params.data) {
            if (typeof params.data === 'string') {
                params.headers = params.headers || {'Content-Type': 'application/x-www-form-urlencoded'};
                params.body = params.data;
            } else {
                if (!(params.data instanceof FormData)) {
                    params.headers = params.headers || {'Content-Type': 'application/json'};
                    params.body = JSON.stringify(params.data);
                } else {
                    params.body = params.data;
                }
            }
        }
        return $s.fetch({...params, method: 'POST'});
    }

    this.fetch = function (params) {
        const controller = new AbortController();
        const config = {
            method: params.method || 'GET',
            headers: params.headers,
            mode: params.mode || 'cors',
            body: params.body,
            signal: controller.signal
        };

        function parseResponse(text) {
            var data = text;
            if (params.type == 'json') {
                try {
                    data = JSON.parse(text);
                } catch (e) {
                    data = {};
                    console.error('parseResponse error, cannot JSON.parse: ', text);
                }
            }
            return data;
        }

        fetch(params.url, config)
            .then((response) => {
                response.text().then((text) => {
                    if (response.ok) {
                        if (params.success) {
                            params.success(parseResponse(text), response);
                        }
                    } else {
                        if (params.error) {
                            params.error(parseResponse(text), response);
                        }
                    }
                    if (params.always) {
                        params.always();
                    }
                });
            })
            .catch((e) => {
                if (e.name != 'AbortError') {
                    if (params.error) {
                        params.error(parseResponse(''));
                    }
                }
                if (params.always) {
                    params.always();
                }
            });
        return controller;
    }

    this.getDataFromUrls = function (urls) {
        var urlsLoaded = 0;
        var returnData = [];
        var promise = new Promise((resolve, reject) => {
            urls.forEach(function (url) {
                returnData[url] = null;
                $s.get({
                    url: url,
                    success: function (data) {
                        returnData[url] = data;
                    },
                    always: function (data) {
                        urlsLoaded++;
                        if (urls.length == urlsLoaded) {
                            resolve(returnData);
                        }
                    }
                })
            });
        })
        return promise;
    }

    this.getProducts = async function (handles) {
        var urls = handles.map((x) => '/products/' + x + '.js');
        var response = await $s.getDataFromUrls(urls);
        var ret = [];
        var i = 0;
        for (var url in response) {
            ret[handles[i++]] = response[url] ? JSON.parse(response[url]) : null;
        }
        return ret;
    }

    this.setHeaderSubmenus = function () {
        var hasDropDowns = document.querySelectorAll('.header-main-menu .has-dropdown:not(.submenu-initialized)');
        hasDropDowns.forEach(function (obj) {
            obj.classList.add('submenu-initialized');
            var submenu = obj.querySelector('.submenu');
            
            hoverintent(obj,
                function () {
                    $s.expand([submenu]);
                    updateAriaExpanded(obj, true);
                }, function () {
                    $s.collapse([submenu]);
                    updateAriaExpanded(obj, false);
                    obj.classList.remove('submenu-open');
                }
            ).options({timeout: 300});

            obj.addEventListener('focusin', function () {
                $s.expand([submenu]);
                obj.classList.add('submenu-open');
                updateAriaExpanded(obj, true);
            });

            obj.addEventListener('focusout', function (e) {
                if (!obj.contains(e.relatedTarget)) {
                    $s.collapse([submenu]);
                    obj.classList.remove('submenu-open');
                    updateAriaExpanded(obj, false);
                }
            });
            
            // Handle submenu toggle buttons (for keyboard accessibility)
            var toggleBtn = obj.querySelector('.submenu-toggle, button.menu-toggle-btn');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    var isOpen = obj.classList.contains('submenu-open');
                    if (isOpen) {
                        $s.collapse([submenu]);
                        obj.classList.remove('submenu-open');
                        updateAriaExpanded(obj, false);
                    } else {
                        $s.expand([submenu]);
                        obj.classList.add('submenu-open');
                        updateAriaExpanded(obj, true);
                        // Focus first link in submenu
                        var firstLink = submenu.querySelector('a');
                        if (firstLink) firstLink.focus();
                    }
                });
                
                toggleBtn.addEventListener('keydown', function (e) {
                    if (e.which == 27) { // Escape key
                        e.preventDefault();
                        $s.collapse([submenu]);
                        obj.classList.remove('submenu-open');
                        updateAriaExpanded(obj, false);
                        toggleBtn.focus();
                    }
                });
            }
            
            obj.querySelectorAll('a').forEach(function (link) {
                link.addEventListener('keydown', function (e) {
                    if (e.which == 32) { //Spacebar
                        e.preventDefault();
                        $s.toggle([link.nextSibling]);
                    }
                    if (e.which == 40) { //Arrow Down
                        e.preventDefault();
                        $s.expand([link.nextSibling]);
                    }
                    if (e.which == 38) { //Arrow Up
                        e.preventDefault();
                        $s.collapse([link.nextSibling]);
                    }
                    if (e.which == 27) { // Escape key - close menu and return focus
                        e.preventDefault();
                        $s.collapse([submenu]);
                        obj.classList.remove('submenu-open');
                        updateAriaExpanded(obj, false);
                        var toggleBtn = obj.querySelector('.submenu-toggle, button.menu-toggle-btn, .nav-1');
                        if (toggleBtn) toggleBtn.focus();
                    }
                    if (link.closest('.submenu')) {
                        if (e.which == 39) { //Arrow Right
                            e.preventDefault();
                            $s.expand([link.nextSibling]);
                        }
                        if (e.which == 37) { //Arrow Left
                            e.preventDefault();
                            $s.collapse([link.nextSibling]);
                        }
                    }
                });
            });
        });
        
        // Helper function to update aria-expanded on toggle buttons
        function updateAriaExpanded(container, isExpanded) {
            var toggleBtn = container.querySelector('.submenu-toggle, button.menu-toggle-btn');
            if (toggleBtn) {
                toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            }
        }
    }

    function setHeaderSearch() {
        var bar = document.getElementById('search-bar');
        if (bar) {
            var header = document.querySelector('.header-inner');
            header.appendChild(bar);
            var stateOpen = false;
            var button = header.querySelector('.trigger-search')
            var buttonClose = header.querySelector('#header .close-search-bar')

            function toggleSearchBar() {
                stateOpen = !stateOpen;
                if (stateOpen) {
                    button.setAttribute('aria-expanded', 'true')
                    bar.classList.remove('close');
                    bar.classList.add('open');
                    setTimeout(function () {
                        bar.querySelector('[name="q"]').focus();
                    }, 100);
                } else {
                    button.setAttribute('aria-expanded', 'false')
                    bar.querySelector('search-form').clearResults();
                    bar.classList.remove('open');
                    bar.classList.add('close');
                }
            }

            button.addEventListener('click', toggleSearchBar);
            if (buttonClose) {
                buttonClose.addEventListener('click', toggleSearchBar);
            }
        }
    }

    function loadSectionsAsync() {
        var mobileMenuLoaded = false;

        function loadMobileMenu() {
            if ($s.media.isMediumDown) {
                if (!mobileMenuLoaded && !document.getElementById('shopify-section-mobile_menu')) {
                    mobileMenuLoaded = true;
                    window.removeEventListener('mediaChange', loadMobileMenu);
                    $s.getJson({
                        url: location.pathname + '?sections=mobile_menu', success: function (data) {
                            if (data["mobile_menu"]) {
                                var header = document.getElementById('header');
                                header.insertAdjacentHTML("afterend", data["mobile_menu"]);
                                $s.globalEval(data["mobile_menu"]);
                            }
                        }
                    })
                }
            }
        }

        window.addEventListener('mediaChange', loadMobileMenu);
        loadMobileMenu();

        if (window.themeSettings.allowSideCart) {
        function loadSideCart() {
            document.querySelectorAll('.trigger-cart').forEach((element) => {
                element.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.SideCart ? window.SideCart.showSideCart(true) : false;
                })
            });

            $s.getJson({
                url: '/?sections=side_cart', success: function (data) {
                    if (data["side_cart"]) {
                        var section = document.getElementById('shopify-section-side_cart');
                        if (section)
                            section.parentNode.removeChild(section);
                        document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
                        $s.globalEval(data["side_cart"]);
                    }
                }
            });
        }

        if (location.pathname != '/cart') {
            loadSideCart();
        }
        }

        function loadCookiesConsent() {
            $s.getJson({
                url: '/?sections=cookies_consent', success: function (data) {
                    if (data["cookies_consent"]) {
                        document.body.insertAdjacentHTML("beforeend", data["cookies_consent"]);
                        $s.globalEval(data["cookies_consent"]);
                    }
                }
            })
        }

        if (Cookies.get('CookiesConsent') != 'true') {
            loadCookiesConsent();
        }

        var megaMenus = window.themeSettings.megaMenus.map(function(m){ return m.key; });
        var megaMenusParentLinks = window.themeSettings.megaMenus.map(function(m){ return m.parentLink; });
        if (megaMenus.length) {
        var megaMenuLoaded = false;

        function loadMegaMenu() {
            if (!megaMenuLoaded && $s.media.isLarge) {
                megaMenuLoaded = true;
                megaMenusParentLinks.forEach(function (parentKey) {
                    var existingSubmenu = document.querySelector('.header-main-menu [data-parent="' + parentKey + '"] .submenu');
                    if (existingSubmenu) {
                        existingSubmenu.remove();
                    }
                })
                window.removeEventListener('mediaChange', loadMegaMenu);
                $s.getJson({
                    url: '/?sections=' + megaMenus.join(','), success: function (data) {
                        megaMenus.forEach(function (item) {
                            if (data[item]) {
                                document.body.insertAdjacentHTML("beforeend", data[item]);
                                $s.globalEval(data[item]);
                            }
                        });
                    }
                });
            }
        }

        window.addEventListener('mediaChange', loadMegaMenu);
        loadMegaMenu();
        }


    }

    function userIsTabbing() {
        window.addEventListener('keydown', function (e) {
            if (e.keyCode === 9) { // tab
                document.body.classList.add('user-is-tabbing');
            }
        });
        document.addEventListener("click", function () {
            document.body.classList.remove('user-is-tabbing');
        });
    }

    var cssVariables = [];
    this.setCssVariable = function (variable, value, context = ':root') {
        let existingItem = cssVariables.find(x => x.variable == variable && x.context == context);
        if (existingItem) {
            existingItem.value = value;
        } else {
            cssVariables.push({variable, value, context});
        }
        let cssVariablesElement = document.getElementById('css-variables');
        if (cssVariablesElement) {
            cssVariablesElement.remove();
        }
        var variables = '';
        cssVariables.map(x => {
            return x.context
        }).filter((x, i, a) => a.indexOf(x) == i).forEach((varContext) => {
            variables += varContext + ' {';
            cssVariables.filter(x => x.context == varContext).forEach((cssVariable) => {
                variables += `--${cssVariable.variable}: ${cssVariable.value};`;
            });
            variables += '}';
        });
        document.head.insertAdjacentHTML("beforeend", `<style id="css-variables">${variables}</style>`);
    }

    this.init = function () {
        if (!isMobile.any) {
            document.body.classList.add('not-mobile');
        }
        userIsTabbing();
        loadSectionsAsync();
        this.setHeaderSubmenus();
        setHeaderSearch();
        window.dispatchEvent(new CustomEvent('global:js:loaded'));
    }

    this.convertCurrency = function (amount) {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
            const rate = parseFloat(window.Shopify.currency.rate);
            return amount * rate
        }
        return amount;
    }

    this.money = function (value, convert) {
        const money = new Intl.NumberFormat((window.Shopify.locale || "en") + "-" + (window.Shopify.country || "US"), {
            style: 'currency',
            currency: window.Shopify.currency.active || 'USD'
        }).format(convert ? self.convertCurrency(value) : value);
        const formated = money.replace(/[a-zA-Z]+/g, "");
        return isNaN(parseFloat(formated)) ? formated : money;
    }

    this.scrollIntoView = function (element, options, container){
        if(!options) options = {};
        if(!container) container = window;
        const top = element.getBoundingClientRect().top;
        const left = element.getBoundingClientRect().left;
        const offsetPositionTop = top - options.top || 0;
        const offsetPositionLeft = left - options.left || 0;

        container.scrollBy({
            top: offsetPositionTop,
            left: offsetPositionLeft,
            behavior: options.behavior || "smooth"
        });
    }
}

window.$ = window.$ || document.querySelector;
$s.init();

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        $s.hideLoadingOverlay();
    }
}, false);

/** QUASI-GLOBAL COMPONENTS **/
/* components below are used in the page main html, not from other features loaded async */

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true})

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.currentTarget.classList.contains('plus') ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('quantity-input', QuantityInput);

class CartPropertyField extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input, textarea');
        this.input.addEventListener('input', this.onValueChange.bind(this));
        this.input.addEventListener('change', this.onValueChange.bind(this));
        this.saveDelay = 1000;
        this.saveTimeout = null;
        //TODO: this.preventUnload = !this.dataset.preventUnload;
        //TODO: this.preventSubmitClick = !this.dataset.preventSubmitClick;
        this.requestController = null;
        this.badge = document.createElement('div');
        this.badge.innerHTML = 'Saving';
        this.badge.classList.add('badge');
        this.appendChild(this.badge);
        this.lastValueSent = null;
    }

    onValueChange(event) {
        clearTimeout(this.saveTimeout);
        var self = this;
        this.saveTimeout = setTimeout(function () {
            if (self.lastValueSent == self.input.value) {
                return;
            }
            self.lastValueSent = self.input.value;
            var data = self.input.name + '=' + encodeURIComponent(self.input.value);

            //TODO: lock submitClick and unload

            self.badge.classList.add('show');
            if (self.requestController) {
                self.requestController.abort();
            }
            self.requestController = $s.post({
                type: 'POST',
                url: '/cart/update.js',
                data: data,
                dataType: 'json',
                success: function () {
                },
                error: function (response) {
                    var response = JSON.parse(jqXHR.responseText);
                    $s.openModal('<div class="error-itemincart">' + response.description + '</div>', 'message');
                },
                always: function () {
                    self.requestController = null;
                    //TODO: unlock submit and unload
                    self.badge.classList.remove('show');
                }
            });
        }, event.type == 'change' ? 1 : this.saveDelay);
    }
}
customElements.define('cart-property-field', CartPropertyField);

class AddToCartForm extends HTMLElement {
    constructor() {
        super();
        var self = this;

        function submit(data) {
            $s.showLoadingOverlay();
            $s.post({
                url: '/cart/add.js',
                data: data,
                success: function () {
                    $s.addToCartSuccess();
                },
                error: function (response) {
                    $s.addToCartFail(response.description);
                }
            })

        }

        this.querySelector('form').addEventListener('submit', (e) => {
            e.preventDefault();
            //TODO: up sells & cross sells
            var data = new FormData(e.target);
            var crossUpSell = self.querySelector('cross-up-sells');
            if (crossUpSell && window.showCrossUpSellPopup) {
                $s.showLoadingOverlay();
                showCrossUpSellPopup(data, crossUpSell, submit);
            } else {
                submit(data);
            }
        });
    }
}
customElements.define('add-to-cart-form', AddToCartForm);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        this.querySelector('.deferred-media-poster').addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            //window.pauseAllMedia();
            this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

// Shopify's video_tag emits a fallback <img> with no alt and no way to set one.
function labelVideoFallbackImages(root) {
    root.querySelectorAll('video > img:not([alt])').forEach(function (img) {
        img.setAttribute('alt', '');
    });
}

document.addEventListener('DOMContentLoaded', function () {
    labelVideoFallbackImages(document);

    new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === Node.ELEMENT_NODE) labelVideoFallbackImages(node);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });
});
